// ISO 3166-1 alpha-2 → regional-indicator emoji flag.
// Returns the globe for null / empty / malformed codes.
export function flagEmoji(cc: string | null | undefined): string {
  if (!cc || cc.length !== 2) return "🌍";
  const upper = cc.toUpperCase();
  const A = 0x1f1e6;
  const base = "A".charCodeAt(0);
  return (
    String.fromCodePoint(A + (upper.charCodeAt(0) - base)) +
    String.fromCodePoint(A + (upper.charCodeAt(1) - base))
  );
}
